<app-loader *ngIf="filterDataLoading"></app-loader>

<div class="pos-r" id="work-shifts-parent-container">
  <app-loader *ngIf="saveCellsLoading"></app-loader>
  <div class="grid grid--va-middle">
    <div class="grid__box">
      <span class="title title--big">График рабочих смен</span>
    </div>
    <div class="grid__box grid__box--size-min" *ngIf="!filterDataLoading">
      <div class="grid grid--va-middle grid--gap-24 font-size-15">
        <div class="grid__box grid__box--size-min">
          <span class="title">Участки</span>
        </div>
        <ng-container *ngIf="workShifts.data.plotsList && workShifts.data.plotsList.length">
          <div class="grid__box grid__box--size-min" *ngFor="let plot of workShifts.data.plotsList">
            <button
              class="ctrl link"
              type="button"
              id="{{ 'appSelectedPlot' + plot.sector_id }}"
              [disabled]="plot.sector_id === workShifts.filter.plotSelected.sector_id || workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode"
              (click)="onChangePlotSelected(plot)"
              [ngClass]="{
                'link--no-underline font-weight-bold': plot.sector_id === workShifts.filter.plotSelected.sector_id,
                'link--disabled': workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode,
                'link--dotted-blue-dark': plot.sector_id !== workShifts.filter.plotSelected.sector_id
              }"
            >
              {{ plot.sector_number_str }}
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="mt-48" *ngIf="!filterDataLoading">
    <app-tabs [justifyContent]="'center'" [tabActive]="workShifts.tabActiveManual" (tabChange)="onChangeScheduleType($event)">
      <left-expanded-block>
        <div class="grid">
          <div class="grid__box grid__box--size-min field__datepicker" ngbDropdown [autoClose]="false">
            <div class="grid grid--va-middle grid--gap-8">
              <div class="grid__box grid__box--size-min pt-4">
                <button
                  class="ctrl"
                  type="button"
                  id="appPreviewScheduleDate"
                  (click)="onWorkShiftsPreviewDateChange()"
                  [disabled]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode"
                >
                  <app-icon [glyph]="'arrow-left'" [size]="'12'" [color]="'gray-dark'"></app-icon>
                </button>
              </div>
              <div class="grid__box grid__box--size-min" style="width: 218px; text-align: center">
                <button
                  class="ctrl title link link--dotted-blue-dark"
                  id="appOpenScheduleCalendar"
                  [class.link--disabled]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode"
                  ngbDropdownToggle
                  [disabled]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode"
                >
                  График на
                  {{ workShifts.filter.monthDate.formattedDate }}
                </button>
              </div>
              <div class="grid__box grid__box--size-min pt-4">
                <button
                  class="ctrl"
                  type="button"
                  id="appNextScheduleDate"
                  (click)="onWorkShiftsNextDateChange()"
                  [disabled]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode"
                >
                  <app-icon [glyph]="'arrow-right'" [size]="'12'" [color]="'gray-dark'"></app-icon>
                </button>
              </div>
            </div>
            <div ngbDropdownMenu class="datepicker-month">
              <app-date-picker
                [startView]="'month'"
                [maxView]="'year'"
                [minView]="'month'"
                [(ngModel)]="workShifts.filter.monthDate.initDate"
                (change)="onWorkShiftsDateChange($event)"
              ></app-date-picker>
              <div class="grid grid--gap-0 ml-8 mr-8 mb-8 pl-4 pr-4">
                <div class="grid__box grid__box--size-min">
                  <span class="link link--dotted-gray-dark" (click)="onSetCurrentDate()">Сейчас</span>
                </div>
                <div class="grid__box grid__box--size-min grid__box--pull-right">
                  <span class="link link--dotted-gray-dark" ngbDropdownToggle>Закрыть</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </left-expanded-block>
      <app-tab [title]="'График по плану'" [id]="'planedTemplateFilter'" [disabled]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode">
        <div class="pos-r padding-24 mt-16" *ngIf="monthDataLoading && workShifts.activeTemplateFilterType === 'planedTemplateFilter'">
          <app-loader></app-loader>
        </div>
        <div class="mt-16" *ngIf="!monthDataLoading">
          <div class="grid grid--va-middle" *ngIf="!workShifts.calendarMetadata.planned_schedule_fixed">
            <div class="grid__box grid__box--size-min">
              <app-role-access [action]="'disable'" [permission]="'schedule.edit'" [placement]="'bottom-left'">
                <button
                  data-role-element
                  type="button"
                  class="button"
                  id="appOpenTemplateFilterPlanned"
                  (click)="onChangeVisibleTemplateFilter()"
                  [disabled]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode"
                >
                  <span [hidden]="!workShifts.planedTemplateFilter.isActiveTemplateFilter">Выйти из заполнения смен по шаблону</span>
                  <span [hidden]="workShifts.planedTemplateFilter.isActiveTemplateFilter">Заполнение смен по шаблону</span>
                </button>
              </app-role-access>
            </div>
            <div class="grid__box">
              <div class="ta-center font-size-12">
                <span class="text-italic color-gray-dark" [hidden]="workShifts.planedValidationState.scheduleCountErrors">
                  До автоматической фиксации осталось
                  <span class="text-italic color-red-dark">{{ workShifts.calendarMetadata.will_be_fixed_in }}</span>
                  дн. Заполните и проверьте график, чтобы зафиксировать план.
                </span>
                <span class="text-italic color-red-dark" [hidden]="!workShifts.planedValidationState.scheduleCountErrors">
                  Найдено ошибок:
                  {{ workShifts.planedValidationState.scheduleCountErrors }}
                </span>
              </div>
            </div>
            <div class="grid__box grid__box--size-min grid__box--pull-right">
              <div class="grid grid--va-middle grid--gap-24">
                <div class="grid__box grid__box--size-min">
                  <div class="grid grid--gap-4">
                    <div class="grid__box grid__box--size-min" [hidden]="!workShifts.planedValidationState.isScheduleChecked">
                      <div class="grid">
                        <div class="grid__box grid__box--size-min" [hidden]="!workShifts.planedValidationState.isScheduleValid">
                          <app-icon [class]="'icon--va-middle'" [glyph]="'accept-round'" [size]="'16'" [color]="'green-dark'"></app-icon>
                        </div>
                        <div class="grid__box grid__box--size-min" [hidden]="workShifts.planedValidationState.isScheduleValid">
                          <app-icon [class]="'icon--va-middle'" [glyph]="'warning-round'" [size]="'16'" [color]="'red-dark'"></app-icon>
                        </div>
                      </div>
                    </div>
                    <div class="grid__box grid__box--size-min">
                      <button
                        type="button"
                        class="ctrl link link--dotted-blue-dark"
                        id="appCheckSchedule"
                        (click)="onCheckStatePlanedSchedule()"
                        [class.link--disabled]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode"
                        [disabled]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode"
                      >
                        Проверить график
                      </button>
                    </div>
                  </div>
                </div>
                <div class="grid__box grid__box--size-min">
                  <app-role-access [action]="'disable'" [permission]="'schedule.fix_planned_schedule'" [placement]="'bottom-right'">
                    <button
                      class="button"
                      id="appFixedSchedule"
                      type="button"
                      [disabled]="!workShifts.planedValidationState.isScheduleValid"
                      (click)="onCheckFixedPlannedSchedule()"
                    >
                      Зафиксировать график
                    </button>
                  </app-role-access>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="workShifts.planedTemplateFilter.isActiveTemplateFilter">
            <app-work-shifts-template-filter
              [filter]="workShifts.filter"
              [templateFilter]="workShifts.planedTemplateFilter"
              [templateFilterData]="workShifts.data"
              (onResetTemplateFilter)="onResetTemplateFilter($event)"
              (onSaveTemplatePeriod)="onSaveTemplatePeriod()"
              (onPreloadTemplatePeriod)="onPreloadTemplatePeriod($event)"
            ></app-work-shifts-template-filter>
          </div>
          <div class="mt-24" *ngIf="workShifts.activeTemplateFilterType === 'planedTemplateFilter'">
            <app-work-shifts-table
              [filter]="workShifts.filter"
              [templateFilter]="workShifts.planedTemplateFilter"
              [templateFilterData]="workShifts.data"
              [calendar]="workShifts.calendarMetadata"
              [users]="workShifts.users"
              [isActiveTemplateFilter]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilter"
              [isActiveTemplateFilterPreviewMode]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode"
              #workShiftsTable
            ></app-work-shifts-table>
          </div>
        </div>
      </app-tab>
      <app-tab
        [title]="'График по факту'"
        [id]="'actualTemplateFilter'"
        [disabled]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode"
        *ngIf="workShifts.calendarMetadata.planned_schedule_fixed"
      >
        <div class="pos-r padding-24 mt-16" *ngIf="monthDataLoading && workShifts.activeTemplateFilterType === 'actualTemplateFilter'">
          <app-loader></app-loader>
        </div>
        <div class="mt-16" *ngIf="!monthDataLoading">
          <div *ngIf="workShifts.actualTemplateFilter.isShowTemplateFilterButton">
            <div class="grid grid--va-middle">
              <div class="grid__box grid__box--size-min">
                <app-role-access [action]="'disable'" [permission]="'schedule.edit'" [placement]="'bottom-left'">
                  <button
                    data-role-element
                    type="button"
                    class="button"
                    id="appOpenTemplateFilterActual"
                    [disabled]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode"
                    (click)="onChangeVisibleTemplateFilter()"
                  >
                    <span [hidden]="!workShifts.actualTemplateFilter.isActiveTemplateFilter">Выйти из заполнения смен по шаблону</span>
                    <span [hidden]="workShifts.actualTemplateFilter.isActiveTemplateFilter">Заполнение смен по шаблону</span>
                  </button>
                </app-role-access>
              </div>
            </div>
          </div>
          <div *ngIf="workShifts.actualTemplateFilter.isActiveTemplateFilter">
            <app-work-shifts-template-filter
              [filter]="workShifts.filter"
              [templateFilter]="workShifts.actualTemplateFilter"
              [templateFilterData]="workShifts.data"
              (onResetTemplateFilter)="onResetTemplateFilter($event)"
              (onSaveTemplatePeriod)="onSaveTemplatePeriod()"
              (onPreloadTemplatePeriod)="onPreloadTemplatePeriod($event)"
            ></app-work-shifts-template-filter>
          </div>
          <div class="mt-24" *ngIf="workShifts.activeTemplateFilterType === 'actualTemplateFilter'">
            <app-work-shifts-table
              [filter]="workShifts.filter"
              [templateFilter]="workShifts.actualTemplateFilter"
              [templateFilterData]="workShifts.data"
              [calendar]="workShifts.calendarMetadata"
              [users]="workShifts.users"
              [isActiveTemplateFilter]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilter"
              [isActiveTemplateFilterPreviewMode]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode"
              #workShiftsTable
            ></app-work-shifts-table>
          </div>
        </div>
      </app-tab>
      <app-tab
        [title]="'График районов'"
        [id]="'resourceDistribution'"
        [disabled]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode"
        *ngIf="isDispatcher"
      >
        <div class="pos-r padding-24 mt-16" *ngIf="monthDataLoading && workShifts.activeTemplateFilterType === 'resourceDistribution'">
          <app-loader></app-loader>
        </div>
        <div class="mt-16" *ngIf="!monthDataLoading && workShifts.activeTemplateFilterType === 'resourceDistribution'">
          <app-resource-distribution #resourceDistributionComponent [filter]="workShifts.filter" [calendar]="workShifts.calendarMetadata"></app-resource-distribution>
        </div>
      </app-tab>
      <app-tab
        [title]="'Правила ограничений работ'"
        [id]="'workRestrictionsRules'"
        [disabled]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode"
        *ngIf="isDispatcher"
      >
        <div class="mt-16" *ngIf="workShifts.activeTemplateFilterType === 'workRestrictionsRules'">
          <app-work-restrictions-rules [filter]="workShifts.filter" [calendar]="workShifts.calendarMetadata"></app-work-restrictions-rules>
        </div>
      </app-tab>
      <right-expanded-block>
        <div class="grid grid--va-middle" *ngIf="workShifts.activeTemplateFilterType !== 'resourceDistribution' && workShifts.activeTemplateFilterType !== 'workRestrictionsRules'">
          <div class="grid__box grid__box--size-min">
            <button type="button" class="button" (click)="exportCSV()">Экспорт в CSV</button>
          </div>
          <div class="grid__box grid__box--size-min">
            <app-field>
              <content-prefix>
                <div class="field__input-prefix">
                  <app-icon [glyph]="'search'" [size]="'16'" [color]="'gray-dark'"></app-icon>
                </div>
              </content-prefix>
              <input
                type="text"
                class="input-text input--prefix"
                id="fullName"
                [disabled]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode"
                [(ngModel)]="workShifts.filter.fullName"
                placeholder="Искать по сотрудникам"
              />
            </app-field>
          </div>
          <div class="grid__box grid__box--size-min">
            <button
              type="button"
              class="button"
              id="appSearchCollaboratorsSchedule"
              [disabled]="!workShifts.filter.fullName || workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode"
              (click)="onSearchUsers()"
            >
              Искать
            </button>
          </div>
          <div class="grid__box grid__box--size-min">
            <button
              type="button"
              class="ctrl link link--dotted-gray-dark"
              id="appResetSearchCollaboratorsSchedule"
              [disabled]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode"
              (click)="onResetName()"
              [class.link--disabled]="workShifts[workShifts.activeTemplateFilterType].isActiveTemplateFilterPreviewMode"
            >
              Сбросить
            </button>
          </div>
        </div>
        <div class="grid grid--va-middle" *ngIf="workShifts.activeTemplateFilterType === 'resourceDistribution'">
          <div class="grid__box grid__box--size-min">
            <app-field>
              <content-prefix>
                <div class="field__input-prefix">
                  <app-icon [glyph]="'search'" [size]="'16'" [color]="'gray-dark'"></app-icon>
                </div>
              </content-prefix>
              <input
                type="text"
                class="input-text input--prefix"
                id="resourceDistributionEmployeeSearch"
                [(ngModel)]="resourceDistributionEmployeeSearch"
                placeholder="Искать по сотрудникам"
              />
            </app-field>
          </div>
          <div class="grid__box grid__box--size-min">
            <button type="button" class="button" id="appSearchResourceDistribution" (click)="onSearchResourceDistributionEmployees()">Применить</button>
          </div>
          <div class="grid__box grid__box--size-min">
            <button type="button" class="ctrl link link--dotted-gray-dark" id="appResetResourceDistribution" (click)="onResetResourceDistributionSearch()">Сбросить</button>
          </div>
        </div>
      </right-expanded-block>
    </app-tabs>
  </div>
</div>
